import React from 'react';
import styled from 'styled-components';

const SubTitle = ( { text }: any ) => {

    return (

        <SubTitleWrapper>
            <h3>{ text }</h3>            
        </SubTitleWrapper>
    )
}


export default SubTitle;


const SubTitleWrapper = styled.div`

    padding: 10px;
    font-size: 24px;
    color: #5f4a03;
    letter-spacing: 2px;
    text-transform: uppercase;
    text-align: center;
    text-decoration: underline;
    margin: 1rem;

`;